import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Utils} from "../../../utils";

export interface QrDialogData {
  assetId: string;
  equipmentName: string;
  serialNumber: string;
}

declare var $;

@Component({
  selector: 'app-qr-dialog',
  templateUrl: './qr-dialog.component.html',
  styleUrls: ['./qr-dialog.component.scss']
})
export class QrDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<QrDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QrDialogData
  ) { }

  ngOnInit(): void {
  }

  downloadQR() {
    Utils.downloadImageFromCanvas($('qrcode.qrcode canvas')[0], `${this.data.equipmentName}-${this.data.serialNumber}.jpg`);
  }

}
